<template>
    <div class='container' ref="containerBox" @scroll="handleScroll">
        <div ref="stickyBox" :class="[{ sticky: isSticky }, { box: !isSticky }]"
            :style="{ background: isSticky ? '#fff' : 'transparent' }">
            <titlePage :isSticky="isSticky" :scrollToTop="scrollToTop"></titlePage>
        </div>
        <div class='contentBox'>
            <div class="content">
                <div class="flex-between" style="align-items: flex-start;">
                    <div
                        style="flex: 0 0 67%;background-color: #fff;padding:5px 45px;border-radius: 16px;padding-bottom: 100px;width: 65%;">
                        <div class="list-box flex-column" style="margin-top: 30px;">
                            <div class="list-item"
                                style="display: flex; flex-direction: column;padding: 0;margin-right: 0;">
                                <div class="card">
                                    <div class="flex-between">
                                        <div class="title">{{ info.title || '' }}</div>
                                        <el-button type="primary" size="mini"
                                            @click.stop="getOrder(info)">接单</el-button>
                                    </div>
                                    <div class="flex" style="margin-top: 2px;">
                                        <div class="tags">{{ info.city_name || '' }}</div>
                                        <div class="tags"
                                            style="padding: 0 10px;border-left: 1px solid #F6F8FE;margin-right: 20px;">
                                            招{{ info.people || 0 }}人
                                        </div>
                                        <div class="tags">发布时间：</div>
                                        <div class="tags">{{ info.create_time || '' }}</div>
                                    </div>
                                    <!--   <div style="margin-top: 10px;" class="PriceText price"> {{ info.pay_list || '' }}</div>
                             <div style="margin-top: 10px;" class="flex-between">
                                    <div class="text">某某某公司</div>
                                    <div class="text" style="color: #999;">2023-06-06</div>
                                </div> -->
                                </div>
                                <div class="GradientBackground flex-between" style="border-radius: 0 0 10px 10px;">
                                    <div>{{ info.pay_list || '' }}</div>
                                    <div class="price">固定金额 {{ info.pay_fee || '' }}</div>
                                </div>
                            </div>
                        </div>
                        <noticePage></noticePage>
                        <div>
                            <div class="line" style="margin: 30px 0;"></div>
                            <div class="flex">
                                <div class="edging"></div>
                                <div class="title">职位信息</div>
                            </div>
                            <div style="margin-top: 20px;" v-html="info.content" class="fwb"></div>
                        </div>
                        <div>
                            <div class="line" style="margin: 30px 0;"></div>
                            <div class="flex">
                                <div class="edging"></div>
                                <div class="title">工作地址</div>
                            </div>
                            <div style="margin-top: 20px;" class="flex-between" v-if="info.is_login == 1">
                                <span>
                                    {{ info.address || '' }}
                                </span>
                            </div>
                            <img :src="require(`@/static/image/index/occupy1.png`)" alt="carousel image"
                                style="width: 210px;height: auto;margin-top: 20px;" v-else />

                            <div v-show="info.is_login == 1">
                                  <div id="mapContainer" style="width:100%; height: 288px;margin-top: 30px;" ></div>
                            </div>
                        </div>
                        <div>
                            <div class="line" style="margin: 30px 0;"></div>
                            <div class="flex">
                                <div class="edging"></div>
                                <div class="title">公司信息</div>
                            </div>
                            <div style="margin-top: 20px;" v-html="info.company_content" v-if="info.is_login == 1">
                            </div>
                            <img :src="require(`@/static/image/index/occupy2.png`)" alt="carousel image"
                               style="width: 210px;height: auto;margin-top: 20px;" v-else />
                        </div>
                    </div>
                    <div style="flex: 0 0 30%; ">
                        <div class="title">推荐订单</div>
                        <div class="list-box flex-column" style="margin-top: 30px;">
                            <div class="list-item cursor boxShadow"
                                style="display: flex; flex-direction: column;padding: 0;margin-right: 0;"
                                v-for="(item, index) in RecommendList" :key="index" @click="getDetailes(item)">
                                <div class="card">
                                    <div class="flex-between">
                                        <div class="title">{{ item.title || '' }}</div>
                                        <el-button type="primary" size="mini"
                                            @click.stop="getOrder(item)">接单</el-button>
                                    </div>
                                    <div class="flex" style="margin-top: 2px;">
                                        <div class="tag">{{ item.city_name || '' }}</div>
                                        <div class="tag">招{{ item.people || 0 }}人</div>
                                    </div>
                                    <div style="margin-top: 10px;" class="PriceText"> {{ item.pay || '' }} </div>
                                    <div class="line"></div>
                                    <div style="margin-top: 10px;" class="flex-between">
                                        <div class="text">{{ item.company || '' }}</div>
                                        <div class="text" style="color: #999;">{{ item.create_time || '' }}</div>
                                    </div>
                                </div>
                                <div class="GradientBackground flex-between" style="border-radius: 0 0 10px 10px;">
                                    <div>{{ item.pay_list || '' }}</div>
                                    <div class="price">固定金额 {{ item.pay_fee || 0 }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <fotterVue></fotterVue>
    </div>
</template>

<script charset="utf-8" src="https://map.qq.com/api/gljs?v=1.exp&key=NK2BZ-2BYKN-D7OFD-SRE2E-E5LSQ-6CBPZ"></script>
<script>
import titlePage from '@/components/titlePage.vue';
import fotterVue from '@/components/fotter.vue';
import noticePage from '@/components/noticePage2.vue'
export default {
    name: '',
    components: {
        titlePage,
        fotterVue,
        noticePage
    },
    data() {
        return {
            searchForm: {
            },
            typeList: [
                // { name: "销售人员", src: "image/index/icon1" },
                { name: "销售人员", src: "require(`@/static/image/index/icon1.png`)" },
                { name: "销售人员", src: "require(`@/static/image/index/icon2.png`)" },
                { name: "销售人员", src: "require(`@/static/image/index/icon3.png`)" },
                { name: "销售人员", src: "require(`@/static/image/index/icon4.png`)" },
                { name: "销售人员", src: "require(`@/static/image/index/icon5.png`)" },
                { name: "销售人员", src: "require(`@/static/image/index/icon6.png`)" },
            ],
            id: '',
            info: {},
            isSticky: false,
            stickyBoxTop: 0,
            RecommendList:[],
        };
    },
    computed: {},
    watch: {},
    mounted() {
        this.scrollToTop()
        this.id = this.$route.query.id
        this.getInfo()
        this.getRecommendList()
    },
    computed: {
  formattedContent() {
    return this.info.content.replace(/\n/g, '<br>');
  }
},

    methods: {
        handleScroll(event) {
            const scrollTop = event.target.scrollTop
            this.isSticky = scrollTop > this.stickyBoxTop;
        },
        scrollToTop() {
            this.$refs.containerBox.scrollTop = 0;
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        getDetailes(item) {
            if(item.id !==this.id){
                this.$router.push({
                    path: '/RecruitmentDetails', query: {
                        id: item.id
                    }
                }); 
            } 
            this.$router.go(0)
        },
        getInfo() {
            this.$api.index.getOrderInfo({ id: this.id }).then(res => { 
                this.loading = false
                if (res.code == 200) {
                    this.info = res.data 
                    this.initMap();
                }
            })
        },
        getRecommendList(){ 
            this.$api.index.getRecommendList( ).then(res => {
                console.log(res, '666'); 
                if (res.code == 200) {
                    this.RecommendList = res.data.list
                } 
            })
        },
        getOrder(item) {
            console.log(item);
            this.$api.index.getOrder({ id: item.id }).then(res => {
                this.loading = false
                if (res.code == 200) {
                    this.$message.success('接单成功')
                }
            })
        },
        getConfig(){ 
            this.$api.index.getConfig().then(res => { 
                if (res.code == 200) { 
                    this.info =  res.data ||{}      
                    this.initMap();
                }
            })
        },
        initMap() {
            if(this.info.is_login == 1){
                 // 初始化地图
                this.map = new window.qq.maps.Map(document.getElementById('mapContainer'), {
                  center: new window.qq.maps.LatLng(this.info.lnglat.split(',')[0],this.info.lnglat.split(',')[1]), // 设置中心点
                  zoom: 14, // 设置缩放级别
                });  
                console.log(this.info.lnglat.split(',')); 
                this.marker = new window.qq.maps.Marker({
                  position: new window.qq.maps.LatLng(this.info.lnglat.split(',')[0],this.info.lnglat.split(',')[1]),
                  map: this.map,
                });
            }
            }, 
        },
    created() {

    },
}
</script>
<style lang='scss' scoped>
.contentBox {
    background: linear-gradient(0deg, #F6F8FE 0%, #F6F8FE 78%, #CEEAFF 100%);
    margin-top: 60px;
    min-height: 55vh;
}

.content {
    padding: 30px 0;
}

.tags {
    padding-right: 10px;
    font-weight: 300;
    font-size: 14px;
    color: #333333;
}
span{
  word-wrap: break-word!important;
   white-space: pre-wrap!important;
}
</style>